<template>
  <div id="ReceivePayment">
    <v-dialog v-model="isOpen" persistent max-width="1200">
      <v-card class="align-center">
        <v-card-title>
          <div class="d-flex align-center justify-space-between w-100">
            <h1>Nova fatura de recebimento</h1>

            <v-btn icon @click="close()" class="align-self-end">
              <v-icon> mdi-close </v-icon>
            </v-btn>
          </div>
        </v-card-title>
        <v-card-text>
          <v-row class="mt-1 receive-payment-info">
            <v-col cols="12">
              <p class="mb-2">Embarcador</p>
              <span>{{ selectedFather.name }}</span>
            </v-col>
            <v-col cols="12" md="3">
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    ref="invoiceDateField"
                    :value="formattedDate"
                    label="Data da Fatura"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="invoiceDate" locale="pt-br"></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="3">
              <v-menu
                ref="menu2"
                v-model="menu2"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    ref="receiptForecastField"
                    :value="formattedDate2"
                    label="Data de Vencimento"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    :rules="[rules.required]"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="receiptForecast" locale="pt-br"></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field v-model="externalInvoiceId" label="Id da Fatura Externa"></v-text-field>
            </v-col>
          </v-row>
          <h1 class="my-6 text-left">Descrição das CTEs Finalizadas</h1>
          <v-row v-if="unselectedFatherItems.length > 0" dense class="mt-4">
            <v-col>
              <v-expansion-panels>
                <v-expansion-panel class="elevation-2">
                  <v-expansion-panel-header class="px-4 panel-header">
                    <h4>O embarcador ainda possui outras CTEs finalizadas disponíveis</h4>
                    <template v-slot:actions>
                      <v-icon color="black"> mdi-chevron-down </v-icon>
                    </template>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <div class="mx-4 mt-4 d-flex flex-column">
                      <v-data-table
                        v-model="unselectedItems"
                        :headers="unselectedFatherItemsColumns"
                        show-select
                        item-key="data.id"
                        :items="unselectedFatherItems"
                        :items-per-page="unselectedFatherItems.length"
                        :page.sync="paginationUnselectedCtes.pageNumber"
                        @update:items-per-page="changeItemsPerPageUnselectedCte"
                        @page-count="paginationUnselectedCtes.totalPages = $event"
                        :footer-props="{
                          'items-per-page-options': [5, 10, 20, 30, 50],
                          itemsPerPageText: 'Itens por página'
                        }"
                      >
                        <template v-slot:[`item.data.costFreight`]="{ item }">
                          {{ transformPrice(item.data.costFreight) }}
                        </template>
                        <template v-slot:[`item.data.observation`]="{ item }">
                          <TruncateDataWithTooltip
                            :data="item.data.observation"
                            :lengthDataToTruncate="10"
                          ></TruncateDataWithTooltip>
                        </template>
                      </v-data-table>
                      <v-pagination
                        v-model="paginationUnselectedCtes.pageNumber"
                        :length="totalPagesTableUnselectedCtes"
                        :total-visible="7"
                        @input="onPageChangeUnselectedCtes"
                        class=""
                      ></v-pagination>
                      <div class="addToInvoice d-flex justify-end">
                        <v-btn
                          :disabled="unselectedItems.length == 0"
                          @click="addToStatement(unselectedItems)"
                          color="success"
                        >
                          Adicionar na Fatura
                        </v-btn>
                      </div>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-data-table
                :headers="statementColumns"
                :items="getValidStatementData"
                :items-per-page="pagination.pageSize"
                :page.sync="pagination.pageNumber"
                @update:items-per-page="changeItemsPerPage"
                @page-count="pagination.totalPages = $event"
                :footer-props="{
                  'items-per-page-options': [5, 10, 20, 30, 50],
                  itemsPerPageText: 'Itens por página'
                }"
                class="elevation-1"
              >
                <template v-slot:[`item.data.costFreight`]="{ item }">
                  {{ transformPrice(item.data.costFreight) }}
                </template>
                <template v-slot:[`item.data.observation`]="{ item }">
                  <TruncateDataWithTooltip
                    :data="item.data.observation"
                    :lengthDataToTruncate="10"
                  ></TruncateDataWithTooltip>
                </template>
                <template v-slot:[`item.removeAction`]="{ item }">
                  <v-btn :disabled="getValidStatementData.length == 1" color="error" @click="removeFromStatement(item)">
                    Remover
                  </v-btn>
                </template>
              </v-data-table>
              <v-pagination
                v-model="pagination.pageNumber"
                :length="totalPagesTable"
                :total-visible="7"
                @input="onPageChange"
              ></v-pagination>
            </v-col>
          </v-row>
          <h1 class="mt-8 mb-4 text-left">Descrição de Adicionais</h1>
          <a href="#/financial/accounts-receivable/aditionals" target="_blank">
            Clique aqui para incluir novos adicionais
          </a>
          <v-row dense class="mt-4">
            <v-col>
              <related-aditionals-panel-receivable
                v-model="relatedAditionals"
                :shipperId="shipperId"
                :aditionalRelated="aditionals"
                @clickAddAditionals="onClickAddRelatedAditional"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-data-table
                :headers="aditionalsHeaders"
                :items="aditionals"
                :items-per-page="aditionals.length"
                no-data-text="Nenhum adicional adicionado"
                hide-default-footer
              >
                <template v-slot:[`item.isDiscount`]="{ item }">
                  {{ getAditionalType(item.isDiscount) }}
                </template>
                <template v-slot:[`item.price`]="{ item }">
                  {{ transformPrice(item.price) }}
                </template>
                <template v-slot:[`item.additionalDate`]="{ item }">
                  {{ formatDate(item.additionalDate) }}
                </template>
                <template v-slot:[`item.accessKeyCte`]="{ item }">
                  <TruncateDataWithTooltip
                    :data="item.accessKeyCte"
                    :lengthDataToTruncate="10"
                  ></TruncateDataWithTooltip>
                </template>
                <template v-slot:[`item.complementaryAccessKeyCte`]="{ item }">
                  <TruncateDataWithTooltip
                    :data="item.complementaryAccessKeyCte"
                    :lengthDataToTruncate="10"
                  ></TruncateDataWithTooltip>
                </template>
                <template v-slot:[`item.justification`]="{ item }">
                  <span>
                    {{ getJustificationName(item.justification) }}
                  </span>
                </template>
                <template v-slot:[`item.observation`]="{ item }">
                  <TruncateDataWithTooltip
                    :data="item.observation"
                    :lengthDataToTruncate="10"
                  ></TruncateDataWithTooltip>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                  <v-btn color="error" @click="removeAditional(item)"> Remover </v-btn>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
          <v-divider inset class="my-6 mx-auto"></v-divider>
          <v-row>
            <v-col class="d-flex justify-space-around mx-12">
              <div class="d-flex money-cards">
                <div class="circle">
                  <v-icon class="pa-3" large color="white"> mdi-cash-minus </v-icon>
                </div>
                <span class="d-flex px-2 flex-column justify-center"
                  >TOTAL DE DÉBITOS
                  <strong>
                    {{ transformPrice(receiptDiscount) }}
                  </strong>
                </span>
              </div>
              <div class="d-flex money-cards">
                <div class="circle">
                  <v-icon class="pa-3" large color="white"> mdi-cash-plus </v-icon>
                </div>
                <span class="d-flex px-2 flex-column justify-center"
                  >TOTAL DE CRÉDITOS
                  <strong>
                    {{ transformPrice(receiptValue) }}
                  </strong>
                </span>
              </div>
              <div class="d-flex money-cards">
                <div class="circle">
                  <v-icon class="pa-3" large color="white"> mdi-cash-register </v-icon>
                </div>
                <span class="d-flex px-2 flex-column justify-center"
                  >TOTAL DA FATURA
                  <strong>
                    {{ transformPrice(totalValueInvoice) }}
                  </strong>
                </span>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="d-flex justify-end py-5">
          <v-btn color="error" class="mx-1 px-5" large @click="close()"> Cancelar </v-btn>
          <v-btn
            color="success"
            class="px-5"
            :disabled="receiptForecast === null"
            :loading="isCreateButtonLoading"
            large
            @click="createInvoice()"
          >
            Criar Fatura de Recebimento
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <MessagesError
      :errors="errors"
      :type="errorsType"
      :error500="error500"
      @closeMessages="(errors = []), (validateKeyCte = null)"
    />
  </div>
</template>

<script>
import { VMoney } from 'v-money';
import { mapActions, mapMutations } from 'vuex';
import maskPrice from '@/utils/maskPrice';
import RelatedAditionalsPanelReceivable from '@/components/AccountsReceivable/RelatedAditionalsPanelReceivable.vue';
import TruncateDataWithTooltip from '@/components/Table/TruncateDataWithTooltip.vue';
import MessagesError from '@/components/MessagesError.vue';

export default {
  name: 'ReceivePayment',
  props: {
    isOpen: {
      default: () => false,
      type: Boolean
    },
    selectedFather: {
      default: () => null,
      type: Object
    },
    deliveryAllItems: {
      default: () => [],
      type: Array
    },
    selectedItems: {
      default: () => [],
      type: Array
    }
  },
  components: {
    RelatedAditionalsPanelReceivable,
    TruncateDataWithTooltip,
    MessagesError
  },
  directives: { money: VMoney },
  data: () => ({
    menu: null,
    menu1: null,
    menu2: null,
    date: null,
    isCreateButtonLoading: false,
    invoiceDate: null,
    receiptForecast: null,
    externalInvoiceId: null,
    isValid: false,
    isButtonAddLoading: false,
    aditional: {
      isDiscount: null,
      price: null,
      justification: null,
      additionalDate: null,
      accessKeyCte: null,
      observation: null
    },
    aditionalType: [
      { text: 'Crédito', value: false },
      { text: 'Débito', value: true }
    ],
    aditionals: [],
    relatedAditionals: [],
    justifications: [],
    unselectedFatherItemsColumns: [
      {
        value: 'data.numberCte',
        text: 'NÚMERO DA CTE'
      },
      {
        value: 'data.boardingNumber',
        text: 'EMBARQUE EXTERNO'
      },
      {
        value: 'data.costFreight',
        text: 'VALOR DO FRETE'
      },
      {
        value: 'data.observation',
        text: 'OBSERVAÇÃO'
      }
    ],
    unselectedItems: [],
    statementData: [],
    ctes: [],
    money: {
      decimal: ',',
      thousands: '.',
      prefix: 'R$ ',
      suffix: '',
      precision: 2,
      masked: false
    },
    rules: {
      required: (value) => !!value || 'Campo obrigatório!',
      aditionalType: (value) => value !== null || 'Campo obrigatório!',
      hasPrice: (value) => {
        return value !== 'R$ 0,00' || 'Campo obrigatório!';
      }
    },
    pagination: {
      pageNumber: 1,
      pageSize: 5,
      totalPages: 0
    },
    paginationUnselectedCtes: {
      pageNumber: 1,
      pageSize: 5,
      totalPages: 0
    },
    validateKeyCte: null,
    errors: [],
    errorsType: 'error',
    error500: null,
    message: null
  }),

  computed: {
    shipperId() {
      const hasSelectedFather = this.selectedFather !== null;
      const isOpen = this.isOpen;
      return isOpen && hasSelectedFather ? this.selectedFather.id : null;
    },

    aditionalsHeaders() {
      return [
        {
          value: 'isDiscount',
          text: 'TIPO',
          sortable: false
        },
        {
          value: 'price',
          text: 'VALOR',
          sortable: false
        },
        {
          value: 'additionalDate',
          text: 'DATA',
          sortable: false
        },
        {
          value: 'accessKeyCte',
          text: 'CHAVE CTE',
          sortable: false
        },
        {
          value: 'complementaryAccessKeyCte',
          text: 'CTE COMPLEMENTAR',
          sortable: false
        },
        {
          value: 'justification',
          text: 'JUSTIFICATIVA',
          sortable: false
        },
        {
          value: 'observation',
          text: 'OBSERVAÇÃO',
          sortable: false
        },
        {
          value: 'actions',
          align: 'end',
          text: '',
          sortable: false
        }
      ];
    },

    formattedDate() {
      const date = this.invoiceDate;
      if (date === null) return '';
      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year}`;
    },

    formattedDate2() {
      const date = this.receiptForecast;
      if (date === null) return '';
      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year}`;
    },

    formattedCreatedDate() {
      const date = this.aditional.additionalDate;
      if (date === null) return '';
      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year}`;
    },

    unselectedFatherItems() {
      const itemsId = this.statementData.map((item) => item.data.id);

      const unselectedFatherItems = this.deliveryAllItems.filter((item) => {
        return !itemsId.includes(item.data.id) && !item.finishedDeliveriesWithoutInvoice;
      });

      return unselectedFatherItems;
    },

    getValidStatementData() {
      const dataItems = this.statementData.filter((item) => !item.data.isAditional);

      return dataItems;
    },

    statementColumns() {
      const delivererColumns = [
        {
          value: `data.numberCte`,
          text: 'NÚMERO CTE',
          sortable: true
        },
        {
          value: `data.boardingNumber`,
          text: 'EMBARQUE EXTERNO',
          sortable: true
        },
        {
          value: 'data.costFreight',
          text: 'VALOR DO FRETE',
          sortable: true
        },
        {
          value: 'data.observation',
          text: 'OBSERVAÇÃO',
          sortable: true
        },
        {
          value: 'removeAction',
          align: 'end',
          sortable: false
        }
      ];
      return delivererColumns;
    },

    receiptDiscount() {
      const aditionalDiscounts = this.aditionals
        .filter((aditional) => aditional.isDiscount)
        .map((aditional) => aditional.price);
      return aditionalDiscounts.reduce((acc, cur) => (acc += cur), 0);
    },

    receiptValue() {
      var totalCredits = 0;
      this.statementData.map((item) => {
        item.data.type === 'Crédito' ? (totalCredits += parseFloat(item.data.costFreight)) : 0;
      });

      const aditionalCredits = this.aditionals
        .filter((aditional) => !aditional.isDiscount)
        .map((aditional) => aditional.price)
        .reduce((acc, cur) => acc + cur, 0);

      const creditsSum = totalCredits + aditionalCredits;
      return creditsSum;
    },

    shouldDisableAddButton() {
      const { isDiscount, price, additionalDate, justification, accessKeyCte } = this.aditional;
      return (
        isDiscount === null ||
        this.transformPriceToSend(price) === 0 ||
        additionalDate === null ||
        justification === null ||
        !accessKeyCte
      );
    },

    shouldDisableJustification() {
      return this.aditional.isDiscount === null;
    },

    justificationsNumber() {
      return this.aditional.isDiscount ? 13 : 12;
    },

    validateKeyCteRules() {
      if (!this.validateKeyCte && this.validateKeyCte !== null) {
        const error = 'Chave da CTE não pertence ao embarcador ou não foi encontrado';
        return error;
      }

      return null;
    },

    totalPagesTable() {
      const totalPages = Math.ceil(this.getValidStatementData.length / this.pagination.pageSize);
      return totalPages;
    },

    totalPagesTableUnselectedCtes() {
      const totalPages = Math.ceil(this.unselectedFatherItems.length / this.paginationUnselectedCtes.pageSize);
      return totalPages;
    },

    totalValueInvoice() {
      const totalValue = this.receiptValue - this.receiptDiscount;
      return totalValue;
    }
  },

  watch: {
    isOpen: {
      handler(isOpen) {
        if (isOpen) {
          this.statementData = this.selectedItems.map((item) => {
            return {
              data: {
                ...item,
                isAditional: false,
                type: 'Crédito'
              },
              key: Math.floor(Math.random() * 90000) + 10000
            };
          });

          setTimeout(() => {
            if (this.$refs['aditionalForm']) {
              this.$refs.aditionalForm.reset();
            }
            if (this.$refs.receiptForecastField) {
              this.$refs.receiptForecastField.resetValidation();
            }
          }, 0);
        }
      }
    },
    'aditional.isDiscount': {
      handler(_, oldIsDiscount) {
        if (oldIsDiscount !== null) {
          this.aditional.justification = null;
        }
        this.fetchAllJustifications();
      }
    }
  },

  async created() {
    const creditsJustifications = await this.getJustifications(12);
    const discountJustifications = await this.getJustifications(13);
    this.setJustificationsById([...discountJustifications, ...creditsJustifications]);
  },

  methods: {
    ...mapActions('NfeStore', ['fetchJustification']),
    ...mapActions('AccountsReceivableStore', ['validateAccessKeyCte']),
    ...mapMutations('NfeStore', ['setJustificationsById']),
    ...mapActions('InvoicesReceivableStore', ['createInvoiceReceivable']),

    async createInvoice() {
      try {
        const model = this.createInvoiceModel();
        this.isCreateButtonLoading = true;

        const data = await this.createInvoiceReceivable(model);
        if (data.success) {
          this.handleSuccessFeedback();
        } else {
          this.errors = data.errors;
          this.errorsType = 'error';
        }
      } catch (e) {
        console.error(e);
        this.errors = ['Opss, algo deu errado!'];
        this.errorsType = e.errors;
      } finally {
        this.isCreateButtonLoading = false;
        this.close();
      }
    },

    createInvoiceModel() {
      const deliveriesId = this.statementData.map((item) => item.data.id);

      const aditionalsIds = this.aditionals.map((item) => item.id);

      const totalValue = Number(this.totalValueInvoice.toFixed(2));

      const model = {
        senderId: this.shipperId,
        invoiceDate: this.invoiceDate,
        receiptForecast: this.receiptForecast,
        deliveriesId: deliveriesId,
        totalValue: Number(totalValue),
        externalInvoiceNumber: this.externalInvoiceId || null,
        additionalsReceivable: {
          id: aditionalsIds
        }
      };

      return model;
    },

    async fetchAllJustifications() {
      try {
        this.justifications = await this.fetchJustification(this.justificationsNumber);
      } catch (e) {
        console.error(e);
      }
    },

    async getJustifications(id) {
      try {
        return this.fetchJustification(id);
      } catch (error) {
        console.error(error);
      }
    },

    addToStatement(newItems) {
      newItems.map((item) => {
        item = {
          data: { ...item.data, type: 'Crédito', isAditional: false },
          key: Math.floor(Math.random() * 90000) + 10000
        };
        this.statementData.push(item);
      });
      this.unselectedItems = [];
    },

    removeFromStatement(itemData) {
      this.statementData = this.statementData.filter((item) => {
        return item.key !== itemData.key;
      });
    },

    removeAditional(aditional) {
      const aditionalIndex = this.aditionals.indexOf(aditional);
      this.aditionals.splice(aditionalIndex, 1);
      if (aditional.isRelatedAditional) {
        this.relatedAditionals = [...this.relatedAditionals, aditional];
      }
    },

    onClickAddRelatedAditional(relatedAditionals) {
      this.aditionals = [...this.aditionals, ...relatedAditionals];
    },

    async isValidateKeyCte(aditional) {
      const params = {
        senderId: this.shipperId,
        accessKeyCte: aditional.accessKeyCte
      };

      const validationResult = await this.validateAccessKeyCte(params);
      if (validationResult.success) {
        return true;
      }

      this.errors = validationResult.errors;
      this.errorsType = 'error';
      setTimeout(() => {
        this.errors = [];
        this.validateKeyCte = null;
      }, 5000);
      return false;
    },

    async onPageChange(page) {
      this.pagination.pageNumber = page;
    },

    changeItemsPerPage(items) {
      this.pagination.pageSize = items;
    },

    async onPageChangeUnselectedCtes(page) {
      this.paginationUnselectedCtes.pageNumber = page;
    },

    changeItemsPerPageUnselectedCte(items) {
      this.paginationUnselectedCtes.pageSize = items;
    },

    getAditionalType(isDiscount) {
      return isDiscount ? 'Débito' : 'Crédito';
    },

    formatDate(date) {
      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year}`;
    },

    transformPrice(price) {
      return maskPrice(price);
    },

    getJustificationName(justification) {
      return typeof justification === 'string' ? justification : justification.name;
    },

    transformPriceToSend(element) {
      if (!element) return null;
      var money = element.toString().trim();
      money = money.replace('R$ ', '').replaceAll('.', '').replace(',', '.');
      return Number(money);
    },

    handleSuccessFeedback() {
      this.errors = ['Fatura criada com sucesso!'];
      this.errorsType = 'success';
      this.$emit('shouldUpdateList');
      this.close();
    },

    async close() {
      await this.reset();
      this.$emit('update:isOpen', false);
    },

    async resetAditional() {
      if (this.$refs.aditionalForm) {
        this.$refs.price.$el.getElementsByTagName('input')[0].value = 0;
        this.$refs.aditionalForm.reset();
      }

      this.aditional = {
        isDiscount: null,
        price: null,
        justification: null,
        additionalDate: null,
        accessKeyCte: null,
        observation: null
      };
    },

    async reset() {
      this.invoiceDate = null;
      this.receiptForecast = null;
      this.aditionals = [];
      this.pagination = {
        pageNumber: 1,
        pageSize: 5,
        totalPages: 0
      };
      this.paginationUnselectedCtes = {
        pageNumber: 1,
        pageSize: 5,
        totalPages: 0
      };
      this.statementData = [];
      await this.resetAditional();
    }
  }
};
</script>

<style lang="scss" scoped>
.panel-header {
  background: $--color-table-offset;
}
.receive-payment-info {
  p {
    color: $--color-primary;
  }
}

.money-cards {
  padding: 10px 28px;
  border-radius: 5px;
  background: #1f77b4;
  color: white;
  span {
    font-size: 0.8rem;
    strong {
      font-size: 1.3rem;
      font-weight: 600;
    }
  }
  .circle {
    background: #1f77b4;
    border: solid 1px white;
    border-radius: 100%;
    padding: 0px;
  }
}

::v-deep.v-input__slot {
  margin: 0;
  padding: 0;

  &::after,
  &::before {
    display: none !important;
  }
}
::v-deep.v-input {
  .v-text-field {
    &__details {
      padding-top: 4px;
      display: inline-block;
    }
  }
}
::v-deep .v-input__append-inner.v-input__append-inner .v-input__icon--clear {
  padding-top: 17px;
}

::v-deep .v-data-table-header tr th {
  background-color: #e0e0e0 !important;
  border: 1px solid #e0e0e0;
}

::v-deep .v-pagination.v-pagination {
  padding-left: 0;
  justify-content: flex-start;
  margin-left: 0;
  position: relative;
  bottom: 60px;
}
::v-deep .addToInvoice {
  position: relative;
  bottom: 30px;
}
</style>
